import styled from "@emotion/styled"
import { motion } from "framer-motion"

import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"

import { pageGradientVar, fontColorVar } from "../colors"

import { surtitle70, headline70, body50 } from "css/text"

export const Bg = styled.div`
  position: sticky;
  width: 100%;
  height: 100vh;
  top: 0;
  background: var(${pageGradientVar});
  grid-column: doc;
  transform: translate3d(0, 0, 0);
`

export const ImgBlock = styled(motion.div)`
  position: sticky;
  width: 100%;
  height: 100vh;
  top: 0;
  margin-block-start: -300vh;
  ${fullGrid}
  grid-template-rows: 1.1fr 0.9fr;
  grid-column: doc;
  justify-items: center;
  align-items: end;
  transform: translate3d(0, 0, 0);
  pointer-events: none;

  ${getMediaQuery("m")} {
    grid-template-rows: 1fr;
  }
  &.sive {
    grid-template-rows: 1fr;
  }
`

export const Block = styled(motion.div)`
  ${fullGrid}
  grid-template-rows: 1fr;
  grid-column: doc;
  height: auto;
  margin-block-start: -100vh;

  ${getMediaQuery("m")} {
    grid-template-rows: 1fr;
  }
`

export const SubContainer = styled(motion.div)`
  padding-block-start: 50vh;
  padding-block-end: 30vh;
  grid-row: 1;
  align-self: start;
  grid-column: main;

  .sive & {
    padding-block-start: 40vh;
    padding-block-end: 60vh;
  }

  ${getMediaQuery("m")} {
    padding-block-start: 30vh;
    padding-block-end: max(50vh, 100%);

    grid-column: col 7 / span 5;
    align-self: center;

    .sive & {
      grid-column: col 2 / span 5;
    }
    .sive.img-first & {
      grid-column: col 7 / span 5;
    }
  }

  ${getMediaQuery("m")} {
    [dir="rtl"] & {
      grid-column: col 2 / span 5;
    }
    [dir="rtl"] .sive & {
      grid-column: col 7 / span 5;
    }
    [dir="rtl"] .sive.img-first & {
      grid-column: col 2 / span 5;
    }
  }
`

export const Hgroup = styled(motion.hgroup)`
  position: relative;
  grid-column: main;
  width: 100%;
  & h2 {
    ${surtitle70}
    margin-block-end: 10px;
  }
  & h3 {
    ${headline70}
  }

  @media (prefers-contrast: no-preference) {
    & h2 {
      color: var(${fontColorVar});
    }

    & h3::first-line {
      color: var(${fontColorVar});
    }
  }
`

export const Paragraph = styled.p`
  ${body50}
  margin-block-start: 20px;
  overflow: hidden;
  position: relative;
  grid-column: main;
  width: 100%;

  & span {
    display: block;
    height: 20px;
  }
`
